/* eslint-disable import/no-anonymous-default-export */
export default {
  mutation: `mutation createVarieties($varieties: [String]) {
        createVarieties(varieties: $varieties)
    }`,
};
